import { Box, Typography } from '@mui/material';
import * as React from 'react';
import { FooterPublic, HeaderPublic } from '../../../components';
import { styles } from './styles';

export interface IPublicFormWrapperProps {
  title: React.ReactNode | string;
  subTitle?: React.ReactNode | string;
  children: React.ReactNode;
  subContent?: React.ReactNode;
  hasBackgroundOffset?: boolean;
}

export function PublicFormWrapper(props: IPublicFormWrapperProps) {
  return (
    <>
      <HeaderPublic />
      <Box sx={styles.wrapper(props.hasBackgroundOffset)}>
        <Box sx={styles.boxContent}>
          <Typography sx={styles.title} variant="h1">
            {props.title}
          </Typography>
          {!!props.subTitle && props.subTitle}
          <Box sx={styles.box}>{props.children}</Box>
          {!!props.subContent && props.subContent}
        </Box>
      </Box>
      <FooterPublic />
    </>
  );
}
